'use client';

/**
 * Fires add_to_cart event for Google Analytics. *Note: Do not ever push PII into the data layer!!*
 *
 * @example
 * const { fireEvent } = useAddToCartItemEvent();
 * fireEvent(items);
 */

import { useCallback } from 'react';
import { sendGTMEvent } from '@next/third-parties/google';
import { ADD_TO_CART_GA4 } from 'constants/analyticsConstants';
import { getQuantityChangeEventData } from 'utils/gaEventAnalytics';
import { UpdateOrderItemResponse } from 'services/order/types';
import { SearchAddToCartItemData } from 'app/[lang]/[esite]/(core)/search/_components/analytics-listener/types';

type AddToCartType = {
  locationId: string;
  itemSummary: Product;
  itemData: UpdateOrderItemResponse | SearchAddToCartItemData;
  itemListId?: string;
  itemListName?: string;
};

export const useAddToCartItemEvent = () => {
  const buildEvent = useCallback(
    ({
      locationId,
      itemSummary,
      itemData,
      itemListId,
      itemListName
    }: AddToCartType) => {
      const { cartDetails, currency, cartItem, value } =
        getQuantityChangeEventData(locationId, itemSummary, itemData);

      return {
        event: ADD_TO_CART_GA4,
        cartDetails,
        ecommerce: {
          item_list_id: itemListId,
          item_list_name: itemListName,
          currency: currency,
          value,
          items: cartItem
        }
      };
    },
    []
  );

  const fireEvent = useCallback(
    (data: AddToCartType) => {
      sendGTMEvent(buildEvent(data));
    },
    [buildEvent]
  );

  return { fireEvent };
};
